import { render, staticRenderFns } from "./ActivationBriefTaskDeliveryProvider.vue?vue&type=template&id=683e68c4&"
import script from "./ActivationBriefTaskDeliveryProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefTaskDeliveryProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports